/**
 * vue-i18n v9+ message compiler treats `@` as linked-message syntax (`@:key`, `@.modifier:key`).
 * Store / ship strings with literal `@` escaped as `{'@'}` (literal interpolation).
 *
 * @see https://vue-i18n.intlify.dev/guide/essentials/syntax.html
 */

const AT_LITERAL_SENTINEL = '\u0000VUE_I18N_AT_LITERAL\u0000';

/**
 * Escape raw `@` for safe use inside vue-i18n messages. Idempotent for already-escaped `{'@'}`.
 * Preserves linked refs: `@:` and `@.`.
 */
export function escapeVueI18nAtInMessageString(str) {
  if (typeof str !== 'string' || !str.includes('@')) return str;
  const tokenized = str.split("{'@'}").join(AT_LITERAL_SENTINEL);
  const escaped = tokenized.replace(/@(?!\.|:)/g, "{'@'}");
  return escaped.split(AT_LITERAL_SENTINEL).join("{'@'}");
}

/**
 * Human-readable form for CMS / JSON editors (inverse of escape for our `{'@'}` convention only).
 */
export function displayVueI18nMessageForEditor(str) {
  if (typeof str !== 'string' || !str.includes("{'@'}")) return str;
  return str.split("{'@'}").join('@');
}

export function escapeVueI18nAtInTranslationsTree(node) {
  if (node === null || node === undefined) return node;
  if (typeof node === 'string') return escapeVueI18nAtInMessageString(node);
  if (Array.isArray(node)) return node.map(escapeVueI18nAtInTranslationsTree);
  if (typeof node === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(node)) {
      out[k] = escapeVueI18nAtInTranslationsTree(v);
    }
    return out;
  }
  return node;
}

/** Inverse of escape tree — for committed JSON / human-readable export (API still returns storage form). */
export function displayVueI18nAtInTranslationsTree(node) {
  if (node === null || node === undefined) return node;
  if (typeof node === 'string') return displayVueI18nMessageForEditor(node);
  if (Array.isArray(node)) return node.map(displayVueI18nAtInTranslationsTree);
  if (typeof node === 'object') {
    const out = {};
    for (const [k, v] of Object.entries(node)) {
      out[k] = displayVueI18nAtInTranslationsTree(v);
    }
    return out;
  }
  return node;
}
